var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"facebook-login",on:{"click":_setup.loginWithFacebook}},[_c(_setup.FacebookSSO)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }